<template>
  <loading-container :loading="form.evalueMetaTypeGeneralLoading || form.evalueCodeTypeGeneralLoading">
    
    <div v-if="!codeValue" class="card-body text-center">
      {{ $t('messages.stock_not_found') }}
    </div>
    <div v-else>
      <span @click="toggleCollapse" style="cursor: pointer;">
          <i class="fas fa-info-circle"></i>
        </span>
        <div v-if="showIntro">
          <p>
            {{ $t("stocks.general.intro") }}
          </p>
        </div>
      <div class="row">
        <div class="align-items-center m-t-20 m-b-20 p-positive col-md-12 col-lg-7">
          <div>
            <vue-speedometer
              :height="240"
              :maxSegmentLabels="1"
              :needleHeightRatio="0.5"
              :needleTransitionDuration="3000"
              :value="mosValueFilter(false)"
              :customSegmentStops="config['General']"
              :currentValueText="mosValueFilter(true)"
              :segmentColors='["var(--red)", "var(--yellow)", "var(--green)", "var(--purple)"]'
              :customSegmentLabels='[
                {
                  text: $t("stocks.mos.poor"),
                  position: "OUTSIDE",
                  color: "#555",
                },
                {
                  text: $t("stocks.mos.fair"),
                  position: "OUTSIDE",
                  color: "#555",
                },
                {
                  text: $t("stocks.mos.good"),
                  position: "OUTSIDE",
                  color: "#555",
                },
                {
                  text: $t("stocks.mos.great"),
                  position: "OUTSIDE",
                  color: "#555",
                },
              ]'
              :minValue="config['General'][0]"
              :maxValue="config['General'][4]"
              needleTransition="easeQuadInOut"
              needleColor="#000"
              :textColor="valueDisplay(mosValueFilter(false))"
            />
          </div>
          <div class="custom-flex chart-range">
            <span>{{ config['General'][0] }}</span>
            <span>{{ config['General'][4] }}</span>
          </div>
          <div class="custom-flex position-relative">
            <div>
              <h2 class="text-success d-inline">
                <div class="counter">{{ evaluationValueFilter(codeValue['General'].value) | numberDisplay }} <span class="currencyFlag">{{ $t('currency') }}</span></div>
              </h2>
              <change-status 
                class="d-inline"
                v-if="codeValue['General'].v_value"
                :status="codeValue['General'].v_value"
                :unit="codeValue['General'].v_value.unit"/>
              <div class="text-left">{{ $t('stocks.intrinsic_value.title') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </loading-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import LoadingContainer from '@/components/Misc/LoadingContainer';
import VueSpeedometer from "vue-speedometer";
import Tooltip from "@/components/Common/Tooltip";
import ChangeStatus from "@/components/Common/ChangeStatus";

export default {
  name: 'EvGeneral',
  components: {
    LoadingContainer,
    VueSpeedometer,
    Tooltip,
    ChangeStatus
  },
  beforeMount() {
    const code = this.defaultCode;
    this.getChartMetaByType({method: 0});
    this.getEvaluationCode({code: code, method: 0});
  },
  data() {
    return {
      showIntro: false
    };
  },
  computed: {
    ...mapGetters({
      config: "evaluation/config",
      codeKey: "evaluation/codeKey",
      codeValue: "evaluation/codeValue",
      form: "evaluation/form",
      defaultCode: "configuration/defaultCode",
    }),
    currentUser() {
      return this.user || {};
    },
    currentRole() {
      return this.currentUser.role;
    },
  },
  methods: {
    ...mapActions({
      setField: "evaluation/setField",
      getChartMetaByType: "evaluation/getChartMetaByType",
      getEvaluationCode: "evaluation/getEvaluationCode",
    }),
    toggleCollapse() {
      this.showIntro = !this.showIntro;
    },
    evaluationValueFilter(value) {
      return _.round(value, 1);
    },
    mosValueFilter(isString) {
      if (isString)
        return (_.round(this.codeValue['General'].current_value * 100, 1)).toString() + '%';
      return _.round(this.codeValue['General'].current_value * 100, 1);
    },
    collapseSidebar(key) {
      this.setField({ key: key, value: !this.form[key] });
    },
    valueDisplay(val) {
      if (val <= this.config['General'][1]) {
        return 'var(--red)';
      } else if (val > this.config['General'][1] && val <= this.config['General'][2]) {
        return 'var(--yellow)';
      } else if (val > this.config['General'][2] && val <= this.config['General'][3]) {
        return 'var(--green)';
      } else if (val > this.config['General'][3] && val <= this.config['General'][4]) {
        return 'var(--purple)';
      }
    }
  },
};
</script>
<style scoped>
.p-positive {
  position: relative;
}
.custom-flex {
  display: flex;
  justify-content: space-between;
  width: 300px;
}
.chart-range {
  position: absolute;
  top: 150px;
  font-size: 16px;
  font-weight: bold;
}
</style>
